import { render, staticRenderFns } from "./FormStory.vue?vue&type=template&id=563d9400&"
import script from "./FormStory.vue?vue&type=script&lang=js&"
export * from "./FormStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports